import { dateTimeToLocal, dateTimeToLocalDate, dateTimeToLocalTime } from './dateTimeToLocal';
import { Session } from './types';

export function getSessionDate(session: Session) {
  return session.startDateTime
    ? dateTimeToLocalDate(session.startDateTime)
    : session.startDay
      ? session.startDay
      : 'Unscheduled';
}

export function getSessionDateTime(session: Session) {
  return session.startDateTime
    ? dateTimeToLocal(session.startDateTime)
    : session.startDay
      ? `${session.startDay} @ ${dateTimeToLocalTime(session.startTime) || 'TBD'}`
      : 'Unscheduled';
}

export function getSessionTime(session: Session) {
  return session.startDateTime
    ? dateTimeToLocalTime(session.startDateTime)
    : session.startTime
      ? dateTimeToLocalTime(session.startTime)
      : 'TBD';
}
